import { NgModule } from '@angular/core';
import { BulletinFormModule } from './bulletin-form/bulletin-form.module';
import { BulletinListModule } from './bulletin-list/bulletin-list.module';
import { BulletinReportModule } from './bulletin-report/bulletin-report.module';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';

@NgModule({
    imports: [
        BulletinFormModule,
        BulletinListModule,
        MessageModule,
        MessagesModule,
        BulletinReportModule
    ] 
})
export class BulletinsModule{

}